import React, { useState } from "react";
import { connect } from "react-redux";
import { Select, Modal } from "antd";
import { rangeGenerator } from "../../../base/utils";
import { Note } from "../../../helbest";
import { API } from "../../../request/api";

// icons
import { ReactComponent as BottomArrow } from "../../../assets/svg/bottom-arrow.svg";
import IconCross from "../../../assets/images/icons/cross_rv.png";
import IconCar from "../../../assets/images/icons/car.png";
import Button from "../../components/ui/Button";

const { Option } = Select;

const grDates = rangeGenerator(2022, 1980);

const CreateCar = (props) => {
  const { new_car, addCar, closeModal } = props;
  const [models, set_models] = useState([]);
  const [brands, set_brands] = useState([]);

  const [state, set_state] = useState({
    type_selected: null,
    brand_selected: null,
    model_selected: null,
    year: null,
    btn_save: "Submit",
  });

  const handleSelectType = (type) => {
    set_state({
      ...state,
      type_selected: type,
      brand_selected: null,
      model_selected: null,
      year: null,
    });

    API.get
      .carsBrands(type)
      .then((response) => {
        if (response.success) {
          set_brands(response.data);
        }
      })
      .catch((error) => {
        console.log("Error : ", error);
      });
  };

  const handleSelectBrand = (br) => {
    set_state({
      ...state,
      brand_selected: br,
      model_selected: null,
      year: null,
    });
    API.get
      .carsModels(br)
      .then((response) => {
        if (response.success) {
          set_models(response.data);
        }
      })
      .catch((error) => {
        console.log("Error : ", error);
      });
  };

  const handleSelectModel = (model) => {
    set_state({
      ...state,
      model_selected: model,
    });
  };

  const handleSelectYear = (year) => {
    set_state({
      ...state,
      year: year,
    });
  };

  const handleSetNewCar = () => {
    if (
      state.year != null &&
      state.type_selected != null &&
      state.brand_selected &&
      state.model_selected != null
    ) {
      set_state({
        ...state,
        btn_save: "please wait...",
      });

      API.post
        .userCar(state.model_selected.id, state.year)
        .then((response) => {
          addCar(response.data);
          closeModal();
          clearData();
        })
        .catch((error) => {
          console.log("Error: ", error);
        });
    } else {
      Note.error("please enter complete information.");
    }
  };

  const clearData = () => {
    set_state({
      type_selected: null,
      brand_selected: null,
      model_selected: null,
      year: null,
      btn_save: "Submit",
    });
  };

  return (
    <Modal
      closeIcon={
        <img
          src={IconCross}
          style={{ width: "20px", height: "20px" }}
          alt="xx"
        />
      }
      onCancel={() => {
        closeModal();
        /*
         * if user change the data and regrets changing the states
         * all states will be cleared
         */
        if (
          state.type_selected ||
          state.brand_selected ||
          state.model_selected ||
          state.year
        ) {
          clearData();
        }
      }}
      title=""
      open={new_car}
      footer={false}
    >
      <div className="flex column">
        <div className="flex flex-column center-content icon_modal_my_new_car center column mt-5">
          <img className="cars-modal-icon" src={IconCar} alt="car" />
          <label>Select a Car</label>
        </div>
        <div className="create_car_box flex column center">
          <div className="select_box col12">
            <Select
              className="selectCarModalSelectBox"
              notFoundContent="no items found"
              bordered={false}
              placeholder="type"
              defaultValue="type"
              suffixIcon={<BottomArrow width={10} height={10} />}
              value={state.type_selected}
              onChange={(type) => handleSelectType(type)}
            >
              <Option className="dir-rtl" value="riding" key="riding">
                Passenger vehicle
              </Option>
              <Option className="dir-rtl" value="heavy" key="heavy">
                Commercial vehicle
              </Option>
            </Select>
          </div>
          <div className="select_box col12">
            <Select
              className="selectCarModalSelectBox"
              notFoundContent="no items found"
              bordered={false}
              placeholder="brand"
              defaultValue="brand"
              disabled={!state.type_selected}
              suffixIcon={<BottomArrow width={10} height={10} />}
              value={state.brand_selected}
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(br) => {
                handleSelectBrand(br);
              }}
            >
              {brands.length > 0 &&
                brands.map((val) => {
                  return (
                    <Option className="dir-rtl" value={val.id} key={val.id}>
                      {val.name.toLowerCase()}
                    </Option>
                  );
                })}
            </Select>
          </div>
          <div className="select_box col12">
            <Select
              className="selectCarModalSelectBox"
              notFoundContent="no items found"
              bordered={false}
              placeholder="model"
              defaultValue="model"
              disabled={!state.brand_selected}
              suffixIcon={<BottomArrow width={10} height={10} />}
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              value={state.model_selected?.name}
              onChange={(model) => handleSelectModel(JSON.parse(model))}
            >
              {models.length > 0 &&
                models.map((model) => {
                  return (
                    <Option
                      className="dir-rtl"
                      value={JSON.stringify(model)}
                      key={model.id}
                    >
                      {model.name}
                    </Option>
                  );
                })}
            </Select>
          </div>
          <div className="select_box col12">
            <Select
              className="selectCarModalSelectBox"
              notFoundContent="no items found"
              bordered={false}
              placeholder="year"
              defaultValue="year"
              disabled={!state.model_selected}
              suffixIcon={<BottomArrow width={10} height={10} />}
              value={state.year}
              onChange={(year) => handleSelectYear(year)}
            >
              {grDates.map((val, ind) => {
                return (
                  <Option key={ind} value={val}>
                    {val}
                  </Option>
                );
              })}
            </Select>
            <div className="flex col12 center">
              <Button
                style_width="100%"
                style_marginTop={16}
                className="submit-add-edit-car-btn"
                onClick={handleSetNewCar}
              >
                {state.btn_save}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

const mstp = (state) => ({
  Login: state.Login,
});
export default connect(mstp)(CreateCar);
